import store from '../Store/store'

export default function authHeader() {
    const res = store.getState()?.auth
    if (res?.user?.token) return { Authorization: 'Bearer ' + res?.user?.token }
    else return {}
}
